const coll = document.getElementsByClassName("collapsible");
let i;
for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function (event) {
        const content = this.parentElement.querySelector('.collapsible-content');
        if (event.target.tagName !== 'A') {

            this.classList.toggle("opened")
            if (content.classList.contains('active')) {
                content.style.maxHeight = null;
                content.classList.remove('active');
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
                content.classList.add('active');
            }
        }
    });
}